import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { BottomSheet } from '../bottom.sheet';
import { HandlerService } from '../handler.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-ads-create',
  templateUrl: './ads-create.component.html',
  styleUrls: ['./ads-create.component.scss'],
})
export class AdsCreateComponent {
header;
item: any = {}; orgId:any; orgName:any; orgsData:any = [];

  adType; adName;
  editorConfig = {
    editable: true,
    spellcheck: false,
    height: '8rem',
    minHeight: '3rem',
    placeholder: 'Enter Your Description Here...',
    translate: 'no',
    "toolbar": [
      ["bold", "italic", "underline"],
    ]
  };

  discountName;discountType;discount;

  files: FileList; fileToUpload: File = null; pic: string = 'null';
  files1: FileList; fileToUpload1: File = null;pic1: string = 'null';
  name;  couponCode;  duration; amount;content;instruction;contentUrl;
  edit: boolean = false; id; loader: boolean = false;
  active: boolean = true;
  type: any;
  type1: any;
  reUpload:boolean = false;
  reUpload1:boolean = false;
  url;
  orgs:any=[];
  // orgObjectCurrent:any=[];
  publishInd:boolean=false;
  approveInd:boolean=false;
  imgIcon : boolean = false;
   desksrc;mobsrc;
   allServices:any=[];
   categorysearchtypes:any= [];
   category: any = [];
   itemCategoryObj;
   itemCategory;
   cateName;
   cateId;
   cateCode;
   pacService;
  constructor(public service:ApiService,
    public handler: HandlerService,
    public router: Router,
    public auth: AuthService,
    public bottomSheet: MatBottomSheet,
    public santinizer:DomSanitizer) { }

  ionViewWillEnter(){
    this.orgId= localStorage.getItem('organizationId');
    this.url = window.location.href;
    this.id = window.location.href.split('/').pop();
    this.service.getOrg().subscribe((res:any)=>{
      this.orgsData=res;
      this.orgsData.map(res=>{
        if(res.id==this.orgId){
          this.orgName = res.name
        }
      }) 
    })
    
    
    if (this.url.includes('edit-ad')) {
      this.imgIcon = true;
      this.edit = true;
      this.loader = true;
      this.service.getAdById(this.id).subscribe((res: any) => {
        this.item = res;
        if(this.item.status==1){
          this.publishInd=true;
        }
        if(this.item.status==2 && this.auth.checkCapability('APRADS')){
          this.approveInd=true;
        }
        this.name = res.name;
        this.contentUrl = res.contentUrl;
        this.duration = res.duration;
        this.discount = res.discountPercentage;
        this.couponCode = res.couponCode;
        this.amount = res.discountAmount;
        this.discountType = res.discountType;
        this.discountType == 1 ? this.discountName = 'PERCENTAGE DISCOUNT':this.discountName = 'FIXED AMOUNT';
        this.adType = res.adType;
        this.adType == 1 ? this.adName = 'DISCOUNT VOUCHERS':this.adName = 'IN-APP PROMOTIONS';
        this.instruction = res.instruction;
        this.content = res.content;
        this.active = res.activeInd;
        this.orgId = res.orgId;
        this.service.getOrgById(this.orgId).subscribe((res:any)=>{
          if(res)
          this.orgName=res.code;
        })
        this.type=res.type;
        setTimeout(() => {
          let y = this.orgsData.filter(res1=>{ return res1.id==res.orgId});
          if(y.length > 0)
          this.orgName = y[0].code;
        }, 500);
     
      
        if (this.item.referenceDocsD && this.item.referenceDocsD.length>0 ) {
          let dev1=this.item.referenceDocsD.find(res=>{return res.deviceType==1 || !res.deviceType})
          let dev2=this.item.referenceDocsD.find(res=>{return res.deviceType==2})
          if(dev1){
            this.service.getImage(dev1.id).subscribe(res => {
              this.imgIcon = false;
              if (dev1.type==1 || dev1.type==3) {
                this.pic = 'image';
                let binary = new Uint8Array(res)
                let blob = new Blob([binary], { type: 'image/gif' });
                this.desksrc=this.santinizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob))
              }
              if (dev1.type==2) {
                this.pic = 'video';
                let binary = new Uint8Array(res)
                let blob = new Blob([binary], { type: 'video\/mp4' });
                this.desksrc=this.santinizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob))
              }
            })

          }
          if(dev2){
            this.service.getImage(dev2.id).subscribe(res => {
              this.imgIcon = false;
              if (dev2.type==1 || dev2.type==3) {
                this.pic1 = 'image1';
                let binary = new Uint8Array(res)
                let blob = new Blob([binary], { type: 'image/gif' });
                this.mobsrc=this.santinizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob))
              }
              if (dev2.type==2) {
                this.pic1 = 'video1';
                let binary = new Uint8Array(res)
                let blob = new Blob([binary], { type: 'video\/mp4' });
                this.mobsrc=this.santinizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob))
              }
            })
          }
          this.loader = false;
        }
        else{
          if(res.documentId){
          this.service.getImage(res.documentId).subscribe(res => {
            this.imgIcon = false;
            if (this.item.type == 1) {
              this.pic = 'image';
              let binary = new Uint8Array(res)
              let blob = new Blob([binary], { type: 'image/gif' });
              this.desksrc=this.santinizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob))
            }
            if (this.item.type == 2) {
              this.pic = 'video';
              let binary = new Uint8Array(res)
              let blob = new Blob([binary], { type: 'video\/mp4' });
              this.desksrc=this.santinizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob))
            }
          })
        this.loader = false;
        }
        else{
          this.loader=false;
        }

        }
      }, err => {
        this.loader = false;
        this.handler.err(err)
      })

    }
    if (this.url.includes('post-ad')) {
      this.edit = false;
    }
    this.getCategory(); 
  }

  getCategory(){
    this.service.getOrgCategory().subscribe((res: any) => {
      this.category=res;
       
    })
  }

  openBottomSheetCategoryType(){
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.category,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.cateName = res.name;
        this.cateId = res.id;
        this.cateCode = res.code;
        }
    });
  }
 

  editSave() {
    this.edit = true;
    this.loader = true;
    if (this.name) {
      this.name = this.name.toUpperCase();
    }
    if (this.couponCode) {
      this.couponCode = this.couponCode.toUpperCase();
    }
    this.item.name = this.name;
    this.item.contentUrl = this.contentUrl;
    this.item.duration = this.duration;
    this.item.discountPercentage = this.discount;
    this.item.couponCode = this.couponCode;
    this.item.discountAmount = this.amount;
    this.item.adType = this.adType;
    this.item.content = this.content;
    this.item.instruction = this.instruction;
    this.item.discountType = this.discountType;
    this.item.activeInd = this.active;
    this.item.type=this.type;
    this.item.category = this.cateId;
    this.service.editAd(this.id, this.item).subscribe(res => {
      this.loader = false;
      this.handler.res('Updated Successfully !!');
      window.history.back();
    }, err => {
      this.handler.err(err);
      this.loader = false;
    })
  }

  post() {
    this.edit = false;
    this.loader = true;
    if (this.name) {
      this.name = this.name.toUpperCase();
    }
    if (this.name) {
      this.name = this.name.toUpperCase();
    }
    let postData = {
      "name": this.name,
      "contentUrl" : this.contentUrl,
      "duration": this.duration,
      "discountPercentage": this.discount,
      "couponCode": this.couponCode,
      "discountType": this.discountType,
      "discountAmount": this.amount,
      "adType":this.adType,
      "content":this.content,
      "type": this.type,
      "instruction":this.instruction,
      "category":this.cateId,
      "activeInd": this.active,
      "orgId":this.orgId
    }
    this.service.postAd(postData).subscribe(async (res: any) => {
      if( this.adType == 2){
        this.service.postAdimage1(res.id,1, this.fileToUpload).subscribe(res1 => {
          this.desksrc=this.santinizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(this.fileToUpload))
          this.loader = false;
          this.id=res.id;
          this.publishInd = true;
          this.handler.res("AD Posted Successfully !!");
        }, err => {
          this.loader = false;
          this.handler.err(err);
        })
        this.service.postAdimage1(res.id,2, this.fileToUpload1).subscribe(res1 => {
         this.mobsrc=this.santinizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(this.fileToUpload1))
          this.loader = false;
          this.id=res.id;
          this.publishInd = true;
        }, err => {
          this.loader = false;
          this.handler.err(err);
        })
      }else{
        this.publishInd = true;
        this.id=res.id;
        // this.service.postAdimage1(res.id,2, this.fileToUpload1).subscribe(res1 => {
        //   this.mobsrc=this.santinizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(this.fileToUpload1))
        //    this.loader = false;
        //    this.id=res.id;
        //    this.publishInd = true;
        //  }, err => {
        //    this.loader = false;
        //    this.handler.err(err);
        //  })
      }
      
    })
  
}
publish(){
  this.loader=true;
  this.service.publishAd(this.id).subscribe(res => {
    this.handler.res("AD Published Successfully !!");
    this.loader=false;
    window.history.back();
  },err=>{
    this.loader=false;
    this.handler.err(err);
  })

} 
approve(){
  this.loader=true;
  this.service.approveAd(this.id).subscribe(res => {
    this.handler.res("AD Approved Successfully !!");
    this.loader=false;
    window.history.back();
  },err=>{
    this.loader=false;
    this.handler.err(err);
    this.mobsrc=this.santinizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(this.fileToUpload1))
    this.desksrc=this.santinizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(this.fileToUpload))
  })

}



editDocument(){
  this.editSave();
  if(this.fileToUpload){
    this.service.postAdimage1(this.id,1,this.fileToUpload).subscribe(res=>{
    },err=>{
        this.handler.err(err)
      })
   }
  if(this.fileToUpload1){
        this.service.postAdimage1(this.id,2,this.fileToUpload1).subscribe(res=>{
        },err=>{
            this.handler.err(err)
    })
  }

}


handleFile(files: FileList) {
  if(files[0].type.includes("image")){
  this.type=1;
  this.pic='image'
  }
  else{
  this.pic='video';
  this.type=2;
  }
  this.desksrc=this.santinizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(files[0]))
  this.fileToUpload=files[0];
if (this.url.includes('edit-ad')){
  this.reUpload=true;
}
 
}
handleFile1(files: FileList) {
  if(files[0].type.includes("image")){
    this.pic1='image1'
    this.type=1;
  }
  else{
  this.pic1='video1';
  this.type=2;
  }
  this.mobsrc=this.santinizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(files[0]))
  this.fileToUpload1=files[0]
  if (this.url.includes('edit-ad')){
    this.reUpload=true;
  }

  }
  fileCoversion1(file,id) {
    if(id == 1){
      setTimeout(() => {
        let image1 = document.getElementById('imge1');
        image1.setAttribute('src', URL.createObjectURL(file));
      }, 500);
    }
    else{
    setTimeout(() => {
      let video1 = document.getElementById('vido1');
      video1.setAttribute('src', URL.createObjectURL(file));
    }, 500);
  }
}
cancel() {
 window.history.back();
}

fileCoversion(file,id) {
  if(id == 1){
    setTimeout(() => {
      let image = document.getElementById('image');
      image.setAttribute('src', URL.createObjectURL(file));
    }, 500);
  }
  else{
  setTimeout(() => {
    let video = document.getElementById('video');
    video.setAttribute('src', URL.createObjectURL(file));
  }, 500);
}
}


  openBottomSheet(id): void {
    let x:any;
    if(id == 1)
    x = this.orgsData
    else if(id == 2){
      x = [
        {id:1,name:"DISCOUNT VOUCHERS"},
        {id:2,name:"IN-APP PROMOTIONS"}
      ]
    }
    else if(id == 3){
      x = [
        {id:1,name:"PERCENTAGE DISCOUNT"},
        {id:2,name:"FIXED AMOUNT"}
      ]
    }
    const dialogRef = this.bottomSheet.open(BottomSheet,{
      data: x,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if(id == 1 && res){
        this.orgName = res.name;
        this.orgId = res.id;
      }
      if(id == 2 && res){
          this.adName = res.name;
          this.adType = res.id;
          this.discountType ='2';
      }
      if(id == 3 && res){
        this.discountType = res.id;
        this.discountName = res.name;
      }

    });
  }




  ionViewWillLeave(){
    this.orgId = "";
    this.orgName = "";
    this.name = "";
    this.contentUrl = "";
    this.duration = "";
    this.amount = "";
    this.discount = "";
    this.couponCode = "";
    this.discountType = "";
    this.adName = "";
    this.adType = "";
    this.instruction = "";
    this.content = "";
    this.publishInd=false;
    this.approveInd=false;
    this.desksrc=undefined;
    this.mobsrc=undefined;
    localStorage.removeItem('dashBoardOrgId')
  }



}
